module.exports = __webpack_public_path__ + "static/media/VestasSans-Light.0b65ebd3.woff";